import { useState } from 'react';
import type { DatovkaApiType } from '@gov-nx/api';
import {
	fetchDataBoxesRecipientQuery,
	useAxiosInstance,
	usePoMutation,
	usePoQuery,
} from '@gov-nx/api';

export const useRecipientSearchAutocomplete = () => {
	const [text, setText] = useState<string>('');
	const { axiosInstance } = useAxiosInstance();

	const mainQuery = usePoQuery<DatovkaApiType[]>({
		queryKey: ['recipient-autocomplete', text],
		queryFn: async () => fetchDataBoxesRecipientQuery(axiosInstance, text),
		enabled: text ? text?.length > 2 : false,
		retry: 0,
		refetchOnWindowFocus: false,
	});

	const mutation = usePoMutation({
		mutationFn: async (input: string) =>
			fetchDataBoxesRecipientQuery(axiosInstance, input),
	});

	return {
		isLoading: mainQuery.isLoading,
		isFetching: mainQuery.isFetching,
		result: mainQuery.data,
		text,
		setText,
		searchCallback: async (value: string): Promise<DatovkaApiType[]> =>
			mutation.mutateAsync(value),
	};
};
